import {getSingletonAjaxContainer, loadScriptZoomsounds} from "./_dzswtl_helpers";
import {DZSWTL_FILTERS_SINGLETON, DZSWTL_VIEW_AJAX_MAIN_SHORTCODE_CONTAINER} from "../config/_dzswtl_constants";
import {get_query_arg, add_query_arg} from "../js_common/_dzs_helpers";


/**
 *
 * @param {DzsWooTable} selfClass
 * @returns {boolean}
 */
export function isInfiniteScroll(selfClass) {
  return selfClass['pagination_method'] === 'scroll';

}

/**
 * called after ajax load_new_content success
 * @param selfClass
 * @param arrLoadNewResponse
 * @param pageOptions
 * @param margs
 * @returns {}
 */
export const ajax_handleNewContent = (selfClass, arrLoadNewResponse, pageOptions, margs) => {

  var $ = jQuery;


  var actualSearch_forceUpdateFilters = null;


  if (window.dzsap_settings) {
    if (window.dzsap_init) {
      setTimeout(function () {
        if (window.dzsap_init_allPlayers) {
          window.dzsap_init_allPlayers($);
        }
      }, 2);
    } else {
      loadScriptZoomsounds();
    }
  }




  if (window[DZSWTL_FILTERS_SINGLETON]) {

    window[DZSWTL_FILTERS_SINGLETON].handleAjaxContentLoaded(arrLoadNewResponse)
  }

  try {

  } catch (err) {

    console.error('cannot parse - ', arrLoadNewResponse.margs, err);
  }


  var $ajaxContainer = getSingletonAjaxContainer();

  if (selfClass.cthis.hasClass('woo-table-is-zfolio')) {

  }


  const itemsOutput = String(arrLoadNewResponse.itemsOutput).replace(/dzswtl--item-instance/g, 'dzswtl--item-instance item-transitioning-in');
  if (margs.call_from === 'scroll' && isInfiniteScroll(selfClass)) {
    $ajaxContainer.append(itemsOutput);
  } else {
    $ajaxContainer.html(itemsOutput);
  }

  if (arrLoadNewResponse.footerExtraHtml) {
    $('body').append(arrLoadNewResponse.footerExtraHtml);
  }

  if (arrLoadNewResponse['count-all-number'] && window[DZSWTL_FILTERS_SINGLETON]) {
    window[DZSWTL_FILTERS_SINGLETON].view_updateCountAllFilterNumber(arrLoadNewResponse['count-all-number']);
  }


  if (arrLoadNewResponse.paged && isNaN(Number(arrLoadNewResponse.paged)) === false) {
    pageOptions['pages_curr'] = Number(arrLoadNewResponse.paged);
  } else {
    pageOptions['pages_curr'] = 1;
  }
  pageOptions['pages_max'] = Number(arrLoadNewResponse.max_num_pages);


  var stringPagination = arrLoadNewResponse.paginationString;
  selfClass['$pagination'].html(stringPagination);


  if (isNaN(Number(pageOptions['pages_max'])) === false) {
    selfClass['$targetShop'].attr('data-max_num_pages', pageOptions['pages_max']);
    selfClass['$targetShop'].find('.dzs-pagination').attr('data-max_num_pages', pageOptions['pages_max']);
  } else {
    pageOptions['pages_max'] = Number(selfClass.cthis.attr('data-max_num_pages'));
  }
  if (isNaN(Number(pageOptions['pages_curr'])) === false) {
    selfClass['$targetShop'].attr('data-curr_paged', pageOptions['pages_curr']);
  }


  if (arrLoadNewResponse.product_ids_that_fit_query) {
    window.dzswtl_product_ids_that_fit_query = arrLoadNewResponse.product_ids_that_fit_query;

    if(arrLoadNewResponse.caller_event!=='PAGINATION_EVENT'){

      if(window[DZSWTL_FILTERS_SINGLETON]){
        window[DZSWTL_FILTERS_SINGLETON].filters_recalculateFilterCount();
      }
    }
  }
  if (arrLoadNewResponse.actual_search_forceUpdateFilters) {
    actualSearch_forceUpdateFilters = JSON.parse(arrLoadNewResponse.actual_search_forceUpdateFilters);
  }

  if (arrLoadNewResponse.filters_by_con_output) {

    $('.' + DZSWTL_VIEW_AJAX_MAIN_SHORTCODE_CONTAINER).find('.filtered-by-con').get(0).outerHTML = (arrLoadNewResponse.filters_by_con_output);
  }


  const response = {
    actualSearch_forceUpdateFilters: null
  };

  if (actualSearch_forceUpdateFilters) {
    response.actualSearch_forceUpdateFilters = actualSearch_forceUpdateFilters;
  }


  return response;
}